export default __webpack_public_path__ + "static/media/maxime_contrast_cross.c3569eda.jpg";